let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hiq8F")).then(() => parcelRequire('hT4Zj'));